import { dataConstants } from '../../src/constants';
import _getScreens from "../../lib/screener/userOperations/_getScreens";
import getPageMetaTags from "../../lib/meta/_getMetaTags";
import getStockTabs from "../../lib/stock/_getStockTabsData.js";
import { getHeroContent } from "../../src/utils/helpers";
import useScreenerState from "../../src/hook/useScreenerState";
import IndexScreenerLayout from "../../src/components/Screener/IndexScreenerLayout";

const ScreenerPage = (props) => {
  const { screens, hero } = props || {};

  const state = useScreenerState({
    screens,
    mode: 'index',
  });

  return (
    <IndexScreenerLayout
      state={state}
      pageProps={props}
      breadcrumbs={[{ label: 'Stock Screener' }]}
      pageTitle={hero?.h1 ?? 'Advanced Stock Screener'}
      pageDesc={hero?.desc ?? 'Create your own stock screener with over 80 different screening criteria.'}
    />
  );
};

export async function getStaticProps({ params, tabCode = "SCREEN", preview = false, type = "screen", _ = '' }) {
  const first = 100; const offset = 1; const andor = 'AND';
  const { getScreens } = await _getScreens("") || {};
  const hero_data = (await getStockTabs("AAPL", "HERO")) || [];
  const { getStockTabs: hero } = hero_data || {};
  const meta_tags = (await getPageMetaTags(`/stock-screener`, false)) || {};
  const { getMetaTags } = meta_tags || {};
  return {
    props: {
      screens: getScreens || [],
      hero: getHeroContent(hero, "stock-screener") || {},
      meta_tags: getMetaTags?.tags || null
    },
    revalidate: dataConstants.REVALIDATE_IN.DEFAULT_HOURS,
  };
}

export default ScreenerPage;
